export default `
<!-- Generator: Adobe Illustrator 26.5.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 332 50" style="enable-background:new 0 0 332 50;" xml:space="preserve">
<style type="text/css">
	.st0{clip-path:url(#SVGID_00000118389246543886297760000011716545547929136775_);fill:currentColor;}
	.st1{clip-path:url(#SVGID_00000019665702101572297880000008334545409116590225_);fill:currentColor;}
	.st2{clip-path:url(#SVGID_00000116947932222492090350000005816125751153022649_);fill:currentColor;}
	.st3{clip-path:url(#SVGID_00000152262854740208043480000010396186549898571652_);fill:currentColor;}
	.st4{clip-path:url(#SVGID_00000094602038686532047490000002622778803570849947_);fill:currentColor;}
	.st5{clip-path:url(#SVGID_00000035490946527962463270000016998939205292755625_);fill:currentColor;}
	.st6{clip-path:url(#SVGID_00000046297737623593708150000006215776084222612115_);fill:currentColor;}
	.st7{clip-path:url(#SVGID_00000160904116007909182390000003471381887371541910_);fill:currentColor;}
	.st8{clip-path:url(#SVGID_00000173862109408855319280000011473048560485992337_);fill:currentColor;}
	.st9{clip-path:url(#SVGID_00000180354324867772016580000001078834494639081379_);fill:currentColor;}
</style>
<g>
	<g>
		<defs>
			<rect id="SVGID_1_" x="0.6" y="0.4" width="330.5" height="49.5"/>
		</defs>
		<clipPath id="SVGID_00000087374430077740912930000010963748371157089441_">
			<use xlink:href="#SVGID_1_"  style="overflow:visible;"/>
		</clipPath>
		<path style="clip-path:url(#SVGID_00000087374430077740912930000010963748371157089441_);fill:currentColor;" d="M313.5,46.3
			c-5.3,0-7.9-5-7.9-14.3c0-8.6,2.5-14.2,7.8-14.2c5.2,0,7.8,4.9,7.8,14.1C321.2,40.5,318.8,46.3,313.5,46.3 M313.8,14.7
			c-10.8,0-18,7.3-18,18.2c0,9,6.9,16.8,17.3,16.8c10.7,0,18-7.3,18-18.1C331.1,21.9,324.2,14.7,313.8,14.7"/>
	</g>
	<g>
		<defs>
			<rect id="SVGID_00000120559247107456020140000008772845674470574731_" x="0.6" y="0.4" width="330.5" height="49.5"/>
		</defs>
		<clipPath id="SVGID_00000103970927156740745860000001148204650614946437_">
			<use xlink:href="#SVGID_00000120559247107456020140000008772845674470574731_"  style="overflow:visible;"/>
		</clipPath>
		<path style="clip-path:url(#SVGID_00000103970927156740745860000001148204650614946437_);fill:currentColor;" d="M290.5,26.7
			c0-4.3-0.6-6.3-2.4-8.6c-1.4-1.8-3.9-2.9-6.3-2.9c-2.3,0-6,1-11.4,3.2l-0.8,0.3V0.5c0,0-5.5,1.1-7.4,1.4s-7,0.9-7,0.9v1.4
			c0,0,6.1,1,6.1,1.8v39.8l-5.8,2.4v1.1c0,0,5.9-0.3,10-0.3s9.2,0.3,9.2,0.3v-1.1l-5.1-2.4v-25c1.3-0.4,3.7-0.7,5.7-0.7
			c5,0,7,2.4,7,8.6v17l-4.8,2.4v1.1c0,0,4.7-0.3,9-0.3s9.9,0.3,9.9,0.3v-1.1l-5.9-2.4L290.5,26.7L290.5,26.7z"/>
	</g>
	<g>
		<defs>
			<rect id="SVGID_00000008830167343871646100000015715279713281811612_" x="0.6" y="0.4" width="330.5" height="49.5"/>
		</defs>
		<clipPath id="SVGID_00000051359213836368961570000007290733087966155654_">
			<use xlink:href="#SVGID_00000008830167343871646100000015715279713281811612_"  style="overflow:visible;"/>
		</clipPath>
		<path style="clip-path:url(#SVGID_00000051359213836368961570000007290733087966155654_);fill:currentColor;" d="M215.5,45.8h-15.4
			V27.7H212l2.5,5.8h1.9c0,0-0.3-5.8-0.3-7.7s0.3-7.7,0.3-7.7h-1.9l-2.5,6.2h-11.8V6.7h14.9c0.7,0,3.5,7.6,3.5,7.6h1.8
			c0,0-0.3-2.4-0.3-5.2s0.3-5.8,0.3-5.8s-11.8,0.3-18,0.3s-17-0.3-17-0.3v1.1l5.8,2.4v39l-5.8,2.4l-0.2,1.1c0,0,10.2-0.2,17.2-0.2
			s18.3,0.2,18.3,0.2s0-2.5,0.2-4.8c0.2-2.4,0.6-6.1,0.6-6.1h-2C219.5,38.3,216.3,45.8,215.5,45.8"/>
	</g>
	<g>
		<defs>
			<rect id="SVGID_00000043427330167681421410000002066379364327830677_" x="0.6" y="0.4" width="330.5" height="49.5"/>
		</defs>
		<clipPath id="SVGID_00000121252251944614468770000003706881816241419909_">
			<use xlink:href="#SVGID_00000043427330167681421410000002066379364327830677_"  style="overflow:visible;"/>
		</clipPath>
		<path style="clip-path:url(#SVGID_00000121252251944614468770000003706881816241419909_);fill:currentColor;" d="M224.3,33.3
			c0,9.6,6.5,16.3,15.8,16.3c4.1,0,6.9-1.1,12.9-2.9l-0.2-3.5c0,0-4.4,2.1-7.1,2.1c-8.3,0.1-12.3-5.2-12.3-14c0-7.8,4-13.5,10-12.9
			c4.9,0.5,4.1,6,4.1,6h5.6v-7.8c-4-1-7-1.5-9.9-1.5C231.9,15.1,224.3,22.4,224.3,33.3"/>
	</g>
	<g>
		<defs>
			<rect id="SVGID_00000114055006768095822940000016345741134911833520_" x="0.6" y="0.4" width="330.5" height="49.5"/>
		</defs>
		<clipPath id="SVGID_00000084490139254325977760000005213459121539692978_">
			<use xlink:href="#SVGID_00000114055006768095822940000016345741134911833520_"  style="overflow:visible;"/>
		</clipPath>
		<path style="clip-path:url(#SVGID_00000084490139254325977760000005213459121539692978_);fill:currentColor;" d="M112.4,14.1
			c0,0-5.1,0.9-7.6,1.3c-2.4,0.4-7.2,0.9-7.2,0.9v1.4c0,0,6,1.1,6,1.8v26.2l-6,2.5v1.1c0,0,5.9-0.3,10.4-0.3s10.4,0.3,10.4,0.3v-1.1
			l-6-2.5L112.4,14.1L112.4,14.1z"/>
	</g>
	<g>
		<defs>
			<rect id="SVGID_00000093136095224088682420000006980952507376874938_" x="0.6" y="0.4" width="330.5" height="49.5"/>
		</defs>
		<clipPath id="SVGID_00000124883144879351957340000007150106265959666622_">
			<use xlink:href="#SVGID_00000093136095224088682420000006980952507376874938_"  style="overflow:visible;"/>
		</clipPath>
		<path style="clip-path:url(#SVGID_00000124883144879351957340000007150106265959666622_);fill:currentColor;" d="M108,8.2
			c3.7,0,5.2-1.2,5.2-4c0-2.6-1.6-3.7-5.4-3.7c-3.5,0-5.1,1.3-5.1,3.9C102.6,7.1,104.1,8.2,108,8.2"/>
	</g>
	<g>
		<defs>
			<rect id="SVGID_00000089575801935159456130000001310962513994727583_" x="0.6" y="0.4" width="330.5" height="49.5"/>
		</defs>
		<clipPath id="SVGID_00000088831006547986275690000017555111171217341860_">
			<use xlink:href="#SVGID_00000089575801935159456130000001310962513994727583_"  style="overflow:visible;"/>
		</clipPath>
		<path style="clip-path:url(#SVGID_00000088831006547986275690000017555111171217341860_);fill:currentColor;" d="M156.1,26.4
			c0-4.7-0.5-6.5-2.3-8.8c-1.7-2-3.6-3-6.6-3c-1.5,0-2.9,0.2-4,0.6c-0.6,0.1-1.9,0.6-4,1.4l-3.5,1.3l-0.7,0.2v-4
			c0,0-5.1,0.9-7.6,1.3c-2.4,0.4-7.2,0.9-7.2,0.9v1.4c0,0,6.4,1.1,6.4,1.8v26.2l-6,2.5v1.1c0,0,6-0.2,10.3-0.2s9.4,0.2,9.4,0.2v-1.1
			l-5.3-2.5V23.6l0,0v-3.2c2.4-0.4,3.5-0.6,5.6-0.6c5.4,0,7.1,2,7.1,8.8v17.2l-4.5,2.5v1.1c0,0,4.4-0.3,8.9-0.3s10,0.3,10,0.3v-1.1
			l-5.9-2.5L156.1,26.4z"/>
	</g>
	<g>
		<defs>
			<rect id="SVGID_00000077298876655146047650000014072813116342238894_" x="0.6" y="0.4" width="330.5" height="49.5"/>
		</defs>
		<clipPath id="SVGID_00000055667775142267840050000018429955979309247123_">
			<use xlink:href="#SVGID_00000077298876655146047650000014072813116342238894_"  style="overflow:visible;"/>
		</clipPath>
		<path style="clip-path:url(#SVGID_00000055667775142267840050000018429955979309247123_);fill:currentColor;" d="M53.2,5.7l6-2.5V2.1
			c0,0-5.4,0.3-8.4,0.3c-3,0-6.7-0.3-6.7-0.3L30.6,34.8L17,2.1c0,0-4.7,0.3-7.4,0.3C7,2.4,1.2,2.1,1.2,2.1v1.1l5.9,2.5l-0.6,40
			l-5.9,2.4v1.1c0,0,4.7-0.1,8.2-0.1s8,0.1,8,0.1v-1.1l-5.7-2.5l0.6-33.1L27,49.4c0,0,0.4,0,0.8,0s1,0,1,0l15.3-36.8l0.6,33.1
			l-5.6,2.4v1.1c0,0,6-0.3,10.1-0.3c4.7,0,10.6,0.3,10.6,0.3v-1.1l-6-2.5L53.2,5.7z"/>
	</g>
	<g>
		<defs>
			<rect id="SVGID_00000096032774235383556940000013664596015230829742_" x="0.6" y="0.4" width="330.5" height="49.5"/>
		</defs>
		<clipPath id="SVGID_00000143587450268369357570000010599521318867952807_">
			<use xlink:href="#SVGID_00000096032774235383556940000013664596015230829742_"  style="overflow:visible;"/>
		</clipPath>
		<path style="clip-path:url(#SVGID_00000143587450268369357570000010599521318867952807_);fill:currentColor;" d="M81.2,44.2
			C79.6,44.7,78,45,76.5,45c-3.6,0-5.9-2.1-5.9-5.4c0-3.2,1.3-4.4,6.5-5.5l3.2-0.7l0.9-0.1V44.2z M89.6,43.4V22.9c0-4-0.8-5.4-3.5-7
			c-1.9-1.1-4.2-1.5-7.3-1.5c-3.4,0-8,0.9-14.1,2.7v6.8h5.9c-0.2-2.7,0.3-6.1,5.8-6.2c3.6,0,4.8,1.7,4.8,4.9v8.3
			c-5.8,0.5-9.5,1.1-12.6,1.8c-4.4,1.1-6.7,4-6.7,8.3c0,5.1,3.9,8.8,9.3,8.8c2.5,0,6.3-1.4,10.3-3.8c0,0.5,0,1.7,0,3.1
			c1,0,4.2-0.2,7-0.2s7.2,0.2,7.2,0.2v-1c0,0-5-2-6-2.5L89.6,43.4z"/>
	</g>
	<g>
		<defs>
			<rect id="SVGID_00000169544389238902764030000012399799345698498447_" x="0.6" y="0.4" width="330.5" height="49.5"/>
		</defs>
		<clipPath id="SVGID_00000057865336184446429770000016215616755822072247_">
			<use xlink:href="#SVGID_00000169544389238902764030000012399799345698498447_"  style="overflow:visible;"/>
		</clipPath>

			<rect x="165.2" y="26.1" style="clip-path:url(#SVGID_00000057865336184446429770000016215616755822072247_);fill:currentColor;" width="17.3" height="6.9"/>
	</g>
</g>
</svg>
`;
